import BaseModelAPI from '../BaseModelAPI';

export default class PickingSupplyForProductionList extends BaseModelAPI {

	static entity = 'pickingsupplyforproductionlist'
	static entityName = 'pickingsupplyforproduction';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
